import { useNavigate } from "react-router-dom";
import { getImageUrl } from "../../../lib/get-image";
import { Image } from "../../shared/index";
import { FaChevronRight } from "react-icons/fa";
import styles from "./collection-item.module.css";

const CollectionItem = ({ category }) => {
  const navigate = useNavigate();

  const { name, slug, cat_image } = category;

  const handleCategoryClick = () => {
    const categorySlug = slug || name
      .toLowerCase()
      .trim()
      .replace(/&/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-|-$/g, "");

    navigate(`/shop?category=${encodeURIComponent(categorySlug)}`);
  };

  return (
    <div
      className={styles.collection__card}
      onClick={handleCategoryClick}
      role="button"
      tabIndex={0}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          handleCategoryClick();
        }
      }}
    >
      <div className={styles.left}>
        <Image
          src={getImageUrl(cat_image)}
          alt={name}
          className={styles.image}
        />

        <h3 className={styles.categoryName}>{name}</h3>
      </div>

      <div className={styles.arrow}>
        <FaChevronRight />
      </div>
    </div>
  );
};

export default CollectionItem;